import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { SetupComponent } from './component/setup/setup.component';

const routes: Routes = [
  {
    path: 'guest',
    loadChildren: () => import('./component/guest/guest-routing.module').then(m => m.GuestRoutingModule)
  },
  {
    path: 'setup',
    component: SetupComponent
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    loadChildren: () => import('./component/user/user-routing.module').then(m => m.UserRoutingModule)
  },
  { path: '**', redirectTo: '/guest', pathMatch: 'full' }, // Điều hướng mặc định
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
